// extracted by mini-css-extract-plugin
export default {"root":"wW7QA","myMessage":"zE2Wb","firstInGroup":"vJjaM","lastInGroup":"ThecX","video":"q5beA"};